import UpdateIOUAdjustmentImport from "../UpdateIOUAdjustmentImport/UpdateIOUAdjustmentImport";

const ViewIOUAdjustmentImport = (props) => {
  return <UpdateIOUAdjustmentImport {...props} viewMode={true} />;
};

export default ViewIOUAdjustmentImport;
